/**
 * @generated SignedSource<<a6720baf0d429753b38dec2d4dd7222a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HomeNotificationBellQuery$variables = {};
export type HomeNotificationBellQuery$data = {
  readonly notificationUnreadTotal: {
    readonly " $fragmentSpreads": FragmentRefs<"NotificationBell_total">;
  } | null;
};
export type HomeNotificationBellQuery = {
  response: HomeNotificationBellQuery$data;
  variables: HomeNotificationBellQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "HomeNotificationBellQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationUnreadTotal",
        "kind": "LinkedField",
        "name": "notificationUnreadTotal",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NotificationBell_total"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "HomeNotificationBellQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationUnreadTotal",
        "kind": "LinkedField",
        "name": "notificationUnreadTotal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "count",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f590cc2076c33edd5497e2746f2dc5be",
    "id": null,
    "metadata": {},
    "name": "HomeNotificationBellQuery",
    "operationKind": "query",
    "text": "query HomeNotificationBellQuery {\n  notificationUnreadTotal {\n    ...NotificationBell_total\n    id\n  }\n}\n\nfragment NotificationBell_total on NotificationUnreadTotal {\n  count\n}\n"
  }
};

(node as any).hash = "899198ed542bb066601d49322b3deac4";

export default node;
